<template>
    <section class="col-12 mt-5">
        <label><strong>Quick Links Items</strong></label>
        <div class="table table-responsive">
            <table class="table table-responsive table-striped table-bordered d-table">
                <thead>
                <tr>
                    <td>Module</td>
                    <td>Route</td>
                    <td style="max-width: 50%">Parameters</td>
                    <td>Delete</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, itemIndex) in items">
                    <td>
                        <input type="hidden" :name="'shortcut_link_items['+itemIndex+'][id]'"
                               v-model="item.id">
                        <select @change="getAttributesLink(item.module, item)" :name="'shortcut_link_items['+itemIndex+'][module]'" v-model="item.module"
                                class="form-control">
                            <option v-for="module in modules" :value="module">{{ module }}</option>
                        </select>

                    </td>
                    <td>
                        <input class="form-control mform" :name="'shortcut_link_items['+itemIndex+'][route]'"
                               v-model="item.route">
                    </td>
                    <td @dblclick="addParameter(item)">
                        <span v-if="!item.parameters || item.parameters.length === 0 ">Double click here to add</span>
                        <div v-for="(param, indexParam) in item.parameters" class="d-md-flex"
                             style="max-width: 100%; position: relative">
                              <span title="Remove Parameter" @click="removeParameter(item, indexParam)"
                                    class="fa fa-times text-danger"
                                    style="cursor: pointer;position: absolute; right: 0; padding: 10px;"></span>
                            <select v-model="param.type"
                                    :name="'shortcut_link_items['+itemIndex+'][parameters]['+indexParam+'][type]'">
                                <option value="attr">Attribute</option>
                                <option value="var">Variable</option>
                            </select>


                            <select style="width: 30%" v-if="param.type === 'attr'"
                                    :name="'shortcut_link_items['+itemIndex+'][parameters]['+indexParam+'][key]'"
                                    v-model="param.key">
                                <option value="" class="text-danger" disabled>Key</option>
                                <option v-for="att in item.moduleAttributes" :value="att">{{ att }}</option>
                            </select>

                            <select style="width: 30%" v-if="param.type === 'attr'"
                                    :name="'shortcut_link_items['+itemIndex+'][parameters]['+indexParam+'][value]'"
                                    v-model="param.value">
                                <option class="text-danger" value="" disabled>Value</option>
                                <option v-for="att in attributesModule" :value="att">{{ att }}</option>
                            </select>


                            <input v-if="param.type === 'var'" placeholder="Key" v-model="param.key" style="width: 30%"
                                   :name="'shortcut_link_items['+itemIndex+'][parameters]['+indexParam+'][key]'">
                            <input v-if="param.type === 'var'" placeholder="Value" v-model="param.value"
                                   :name="'shortcut_link_items['+itemIndex+'][parameters]['+indexParam+'][value]'">
                        </div>

                    </td>
                    <td><a @click="deleteLine(item.id, itemIndex)" title="Delete"
                           class="btn btn-danger text-white"><span
                        class="fa fa-trash"></span></a></td>
                </tr>
                </tbody>
                <tfoot>
                <tr>
                    <th colspan="9">
                        <button @click="addLine()" type="button"
                                class="btn btn-success"
                                data-toggle="tooltip"
                                data-original-title="Add more lines">
                            <i class="glyphicon glyphicon-plus-sign"></i>
                            Add
                        </button>

                    </th>

                </tr>
                </tfoot>
            </table>
        </div>
    </section>
</template>

<script>
import {monthNames, URL_BASE, years} from '../../../utils/helper';
import _ from "lodash";
import ShortcutLinkItemModel from "../../../models/ShortcutLinkitemModel";

export default {
    name: "ShortcutLinkItems",
    props: {
        shortcut_links_items: {
            type: Array
        },
        modules: {
            type: Array
        },
    },
    data: function () {
        return {
            items: [],
            attributesModule: [],
            moduleParent: null
        }
    },
    mounted() {
        if (this.shortcut_links_items.length > 0) {
            this.items = this.shortcut_links_items
            this.items.forEach((item) => {
                // Ensure parameters is initialized as an array
                if (!item.parameters) {
                    item.parameters = [];
                }
                // Ensure moduleAttributes is initialized as an array
                if (!item.moduleAttributes) {
                    item.moduleAttributes = [];
                }
                this.getAttributesLink(item.module, item)
            })
        }
    },
    methods: {
        addLine() {
            let item = new ShortcutLinkItemModel()
            this.items.push(item);
        },
        deleteLine(id, itemIndex) {
            if (id) {
                this.$loading(true);
                let app = this;
                axios.delete(URL_BASE + '/shortcut_links/shortcut_links_items/' + id)
                    .then((response) => {
                        this.$loading(false);
                        app.items.splice(itemIndex, 1);
                    })
                    .catch(error => {
                        this.$loading(false);
                        let message = '';
                        if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'Request failed with status code ' + error.response.status;

                        } else {
                            message = 'Application failed with error: ' + error.message;
                            console.log(error);
                        }

                        showMessage('w', message);


                    })
            } else {
                this.items.splice(itemIndex, 1);
            }

        },

        addParameter(shortcutItem) {
            // Ensure parameters is initialized
            if (!shortcutItem.parameters) {
                shortcutItem.parameters = [];
            }
            shortcutItem.parameters.push(
                {
                    type: null,
                    key: '',
                    value: ''
                }
            )
        },

        removeParameter(shortcutItem, indexParam) {
            shortcutItem.parameters.splice(indexParam, 1);
        },

        async getAttributesLink(module, shortcutItem = null) {
            let {data} = await axios.get('/api/module/' + module + '/attributes')
            if (shortcutItem){
                shortcutItem.moduleAttributes = data.data;
            }else {
                this.attributesModule = data.data;
            }
        },

    }
}
</script>

<style scoped>

</style>
